// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.0
//   protoc               unknown
// source: fight/payload/FightPayloadPt.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { ApiResultPayload } from "../../common/model/ApiResultCodePt";
import { WeightClassPayload } from "../model/FightPt";
import { AgeDivisionPayload, ageDivisionPayloadFromJSON, ageDivisionPayloadToJSON } from "../model/enums/AgeDivisionPt";
import { FightSportPayload, fightSportPayloadFromJSON, fightSportPayloadToJSON } from "../model/enums/FightSportPt";
import { GenderPayload, genderPayloadFromJSON, genderPayloadToJSON } from "../model/enums/GenderPt";

export const protobufPackage = "io.teamsillim.fightbracket.idl.fight.payload";

/**
 * 체급 선택지 요청 (참가 신청 화면에서 선수 한 명 기준으로 묻는다)
 *
 * 부(division)는 대회 시작일 + 생년월일로 서버가 정한다 — 학년 계산 규칙을 화면에 복제하지 않으려는 것이다.
 * 그래서 대회 id 와 생년월일이 함께 필요하다.
 */
export interface FightGetWeightClassRequestPayload {
  /** 대회 고유 id (대회 시작일로 부를 산출한다) */
  tournamentId: string;
  /** 참가 종목 */
  sport: FightSportPayload;
  /** 선수 생년월일 (format = yyyy-MM-dd) */
  birthDate: string;
  /** 선수 성별 */
  gender: GenderPayload;
}

/** 체급 선택지 응답 */
export interface FightGetWeightClassResponsePayload {
  /** 결과 */
  result:
    | ApiResultPayload
    | undefined;
  /** 그 선수의 부 · 성별에 해당하는 체급 목록 (체중으로 걸러내지 않는다 — 대회 당일 맞춰 오는 값이다) */
  data: WeightClassPayload[];
  /** 서버가 산출한 부 (화면에 "고등부" 처럼 함께 보여주기 위한 값) */
  division: AgeDivisionPayload;
}

function createBaseFightGetWeightClassRequestPayload(): FightGetWeightClassRequestPayload {
  return { tournamentId: "", sport: 0, birthDate: "", gender: 0 };
}

export const FightGetWeightClassRequestPayload: MessageFns<FightGetWeightClassRequestPayload> = {
  encode(message: FightGetWeightClassRequestPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tournamentId !== "") {
      writer.uint32(10).string(message.tournamentId);
    }
    if (message.sport !== 0) {
      writer.uint32(16).int32(message.sport);
    }
    if (message.birthDate !== "") {
      writer.uint32(26).string(message.birthDate);
    }
    if (message.gender !== 0) {
      writer.uint32(32).int32(message.gender);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FightGetWeightClassRequestPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFightGetWeightClassRequestPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tournamentId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.sport = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.birthDate = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.gender = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FightGetWeightClassRequestPayload {
    return {
      tournamentId: isSet(object.tournamentId) ? globalThis.String(object.tournamentId) : "",
      sport: isSet(object.sport) ? fightSportPayloadFromJSON(object.sport) : 0,
      birthDate: isSet(object.birthDate) ? globalThis.String(object.birthDate) : "",
      gender: isSet(object.gender) ? genderPayloadFromJSON(object.gender) : 0,
    };
  },

  toJSON(message: FightGetWeightClassRequestPayload): unknown {
    const obj: any = {};
    if (message.tournamentId !== "") {
      obj.tournamentId = message.tournamentId;
    }
    if (message.sport !== 0) {
      obj.sport = fightSportPayloadToJSON(message.sport);
    }
    if (message.birthDate !== "") {
      obj.birthDate = message.birthDate;
    }
    if (message.gender !== 0) {
      obj.gender = genderPayloadToJSON(message.gender);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FightGetWeightClassRequestPayload>, I>>(
    base?: I,
  ): FightGetWeightClassRequestPayload {
    return FightGetWeightClassRequestPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FightGetWeightClassRequestPayload>, I>>(
    object: I,
  ): FightGetWeightClassRequestPayload {
    const message = createBaseFightGetWeightClassRequestPayload();
    message.tournamentId = object.tournamentId ?? "";
    message.sport = object.sport ?? 0;
    message.birthDate = object.birthDate ?? "";
    message.gender = object.gender ?? 0;
    return message;
  },
};

function createBaseFightGetWeightClassResponsePayload(): FightGetWeightClassResponsePayload {
  return { result: undefined, data: [], division: 0 };
}

export const FightGetWeightClassResponsePayload: MessageFns<FightGetWeightClassResponsePayload> = {
  encode(message: FightGetWeightClassResponsePayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.result !== undefined) {
      ApiResultPayload.encode(message.result, writer.uint32(10).fork()).join();
    }
    for (const v of message.data) {
      WeightClassPayload.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.division !== 0) {
      writer.uint32(24).int32(message.division);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FightGetWeightClassResponsePayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFightGetWeightClassResponsePayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.result = ApiResultPayload.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.data.push(WeightClassPayload.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.division = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FightGetWeightClassResponsePayload {
    return {
      result: isSet(object.result) ? ApiResultPayload.fromJSON(object.result) : undefined,
      data: globalThis.Array.isArray(object?.data) ? object.data.map((e: any) => WeightClassPayload.fromJSON(e)) : [],
      division: isSet(object.division) ? ageDivisionPayloadFromJSON(object.division) : 0,
    };
  },

  toJSON(message: FightGetWeightClassResponsePayload): unknown {
    const obj: any = {};
    if (message.result !== undefined) {
      obj.result = ApiResultPayload.toJSON(message.result);
    }
    if (message.data?.length) {
      obj.data = message.data.map((e) => WeightClassPayload.toJSON(e));
    }
    if (message.division !== 0) {
      obj.division = ageDivisionPayloadToJSON(message.division);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FightGetWeightClassResponsePayload>, I>>(
    base?: I,
  ): FightGetWeightClassResponsePayload {
    return FightGetWeightClassResponsePayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FightGetWeightClassResponsePayload>, I>>(
    object: I,
  ): FightGetWeightClassResponsePayload {
    const message = createBaseFightGetWeightClassResponsePayload();
    message.result = (object.result !== undefined && object.result !== null)
      ? ApiResultPayload.fromPartial(object.result)
      : undefined;
    message.data = object.data?.map((e) => WeightClassPayload.fromPartial(e)) || [];
    message.division = object.division ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
